import React from 'react';

export default function TermsOfUse() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-6xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">
        <h1 className="text-6xl font-bold text-purple-600 mb-6 text-center">Terms of Use</h1>

        <p className="text-gray-700 mb-6">
          These Terms of Use govern your access and usage of the Million2Trillion (M2T) Platform. By using our services, you agree to comply with these terms. If you do not agree, you should not use this platform.
        </p>

        <h2 className="text-2xl font-semibold text-purple-600  mt-8 mb-2">1. Platform Scope</h2>
        <p className="text-gray-700 mb-6">
          Million2Trillion is a verified global financial marketplace providing digital infrastructure for financial professionals, traders, investors, educators, coders, influencers, and other verified participants.
        </p>

        <h2 className="text-2xl font-semibold text-purple-600 mt-8 mb-2">2. Eligibility & Verified Identity</h2>
        <p className="text-gray-700 mb-6">
          Users must complete identity verification (KYC) and provide accurate personal and professional data. False or misleading information may lead to immediate account termination.
        </p>

        <h2 className="text-2xl font-semibold text-purple-600 mt-8 mb-2">3. Permitted Activities</h2>
        <ul className="list-disc ml-6 space-y-2 text-gray-700 mb-6">
          <li>Participate in trading, education, financial research, and consulting services according to your verified role.</li>
          <li>Respect intellectual property, privacy, and confidentiality obligations.</li>
          <li>Comply with local, national, and international financial laws.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-purple-600 mt-8 mb-2">4. Prohibited Conduct</h2>
        <ul className="list-disc ml-6 space-y-2 text-gray-700 mb-6">
          <li>Fraudulent, misleading, or unauthorized financial advisory services.</li>
          <li>Market manipulation or pump-and-dump activity.</li>
          <li>Violation of regulatory laws related to securities, derivatives, forex, or crypto markets.</li>
          <li>Harassment, abuse, or unprofessional behavior within the community.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-purple-600 mt-8 mb-2">5. Financial Responsibility</h2>
        <p className="text-gray-700 mb-6">
          Million2Trillion does not provide financial advice or investment guarantees. Users are fully responsible for their own financial decisions and risk management.
        </p>

        <h2 className="text-2xl font-semibold text-purple-600 mt-8 mb-2">6. Intellectual Property</h2>
        <p className="text-gray-700 mb-6">
          All content, tools, trademarks, and systems are property of Million2Trillion Global Technologies unless otherwise noted. Unauthorized copying, resale, or distribution is prohibited.
        </p>

        <h2 className="text-2xl font-semibold text-purple-600 mt-8 mb-2">7. Third-Party Services</h2>
        <p className="text-gray-700 mb-6">
          Million2Trillion may collaborate with verified service providers, partners, and data contributors. Users acknowledge that third-party services are bound by their own respective terms.
        </p>

        <h2 className="text-2xl font-semibold text-purple-600 mt-8 mb-2">8. Liability Limitations</h2>
        <p className="text-gray-700 mb-6">
          Million2Trillion is not liable for any direct or indirect losses resulting from trading activities, market movements, or decisions made using information provided on the platform.
        </p>

        <h2 className="text-2xl font-semibold text-purple-600 mt-8 mb-2">9. Suspension & Termination</h2>
        <p className="text-gray-700 mb-6">
          Any violation of these terms may result in temporary or permanent suspension of your verified account and market access.
        </p>

        <h2 className="text-2xl font-semibold text-purple-600 mt-8 mb-2">10. Updates to Terms</h2>
        <p className="text-gray-700 mb-6">
          Million2Trillion reserves the right to update these Terms of Use as regulatory, operational, or legal needs evolve. We encourage you to review them periodically.
        </p>

        <p className="text-gray-400 text-sm mt-10">
          Effective Date: {new Date().getFullYear()} — Million2Trillion Inc.
        </p>
      </div>
    </div>
  );
}
